import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  makeStyles,
  Card,
  CardContent,
  Button,
  CardHeader,
  Select,
  MenuItem,
  // Typography,
  ThemeProvider,
  createTheme,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import {
  Typography,
  Form as AntForm,
  Input as AntInput,
  Select as AntSelect,
  Button as AntButton,
  Card as AntCard,
  Upload,
  Divider,
  Space,
  Row,
  Col,
  Grid as AntGrid, // Import Ant Design Grid for useBreakpoint
  message,
  Form
} from "antd";

import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';


import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import { Formik, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";
import { Link, useParams } from "react-router-dom";
import RegistrationModal from "./modal";
import { CiLocationOn } from "react-icons/ci";
import Marquee from "./Marquee";
import "./App.css";
import UniqueGatePass from "./UniqueGatePass";
import UniqueLimitMsgModal from "./uniqueLimitMsgModal";
import UniqueMobileNumberAlert from "./UniqueMsgModal";
import {
  BankOutlined, MinusCircleOutlined, PhoneOutlined, PlusOutlined, UploadOutlined, UserOutlined, FileImageOutlined,
  VideoCameraOutlined,
  TeamOutlined,
  LinkOutlined,
  GlobalOutlined,
  FileTextOutlined,
  CameraOutlined,
  DesktopOutlined
} from "@ant-design/icons";
import StatusCheckModal from "./StatusCheck";

// Fix: useBreakpoint from Ant Design
const { useBreakpoint } = AntGrid;
const { Option } = AntSelect;
const { Text, Title } = Typography;

// Styles
const useStyles = makeStyles((theme) => ({
  logo: {
    maxWidth: "300px",
    height: "auto",
    margin: "0 auto",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "200px",
    },
  },
  languageSelect: {
    margin: theme.spacing(2, 0),
    minWidth: "50px",
  },
  button: {
    margin: theme.spacing(1),
  },
  padding: {
    padding: theme.spacing(3),
  },
  input: {
    '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-root:before, & .MuiInput-root:after': {
      display: 'none',
    },
    '& .MuiInputBase-input, & input, & textarea': {
      borderBottom: '1px solid rgba(0,0,0,0.25)',
      paddingBottom: 8,
      background: 'transparent',
      boxShadow: 'none',
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(0, 0.75rem) scale(1)',
    },
  },
}));

// Updated Validation Schema
// Fixed validation schema
const validationSchema = Yup.object().shape({
  fullName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Name should only contain letters")
    .required("Full Name is required"),
  mobileNumber: Yup.string()
    .matches(
      /^[6-9]\d{9}$/,
      "Mobile Number must be a valid Indian number starting with 6-9 and 10 digits"
    )
    .required("Mobile Number is required"),
  mediaHouseName: Yup.string().required("Media House Name is required"),
  mediaType: Yup.string().required("Media Type is required"),
  document: Yup.mixed()
    .required("Document is required")
    .test("fileSize", "File size must be less than 5MB", (value) => {
      if (!value) return true; // Skip if no file (handled by required)
      return value.size <= 5 * 1024 * 1024; // 5MB in bytes
    })
    .test("fileType", "Unsupported file format. Only PDF, JPG, JPEG, PNG allowed", (value) => {
      if (!value) return true; // Skip if no file
      const supportedFormats = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
      return supportedFormats.includes(value.type);
    }),
  pressType: Yup.string().when("mediaType", {
    is: "Press",
    then: (schema) => schema.required("Press type is required"),
    otherwise: (schema) => schema.notRequired()
  }),
  photographerName: Yup.string().when(["mediaType", "pressType"], {
    is: (mediaType, pressType) =>
      mediaType === "Press" && pressType === "Print Media",
    then: (schema) => schema.required("Photographer name is required"),
    otherwise: (schema) => schema.notRequired()
  }),
  cameramanName: Yup.string().when(["mediaType", "pressType"], {
    is: (mediaType, pressType) =>
      mediaType === "Press" && pressType === "Electronic Media",
    then: (schema) => schema.required("Cameraman name is required"),
    otherwise: (schema) => schema.notRequired()
  }),
  followersCounts: Yup.array().when("mediaType", {
    is: "Influencer",
    then: (schema) =>
      schema
        .of(
          // accept numeric input as string or number, require digits
          Yup.string()
            .matches(/^\d+$/, "Followers count must be a number")
            .required("Followers count is required")
        )
        .min(1, "At least one followers count is required")
        .required("Followers count is required"),
    otherwise: (schema) => schema.notRequired()
  }),

  socialMediaLinks: Yup.array().when("mediaType", {
    is: "Influencer",
    then: (schema) =>
      schema
        .of(Yup.string().url("Must be a valid URL").required("Link required"))
        .min(1, "At least one social media link is required")
        .required("Social media links are required"),
    otherwise: (schema) => schema.notRequired()
  })
});

const UniqueGatepass = () => {
  const params = useParams();
  const { id } = params;
  const classes = useStyles();
  const submitButtonRef = useRef(null);
  const modalCloseRef = useRef(null);
  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    mediaHouseName: '',
    mediaType: '',
    pressType: '',
    photographerName: '',
    cameramanName: '',
    followersCount: '',
    socialMediaLinks: [''],
    document: null
  });
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusData, setStatusData] = useState(null);
  //console.log("Status Data:", statusData);
  const [searchAttempted, setSearchAttempted] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = React.useState("English");
  const [response, setResponse] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);
  const [megaEvents, setMegaEvents] = useState();
  const [limitMsgOpen, setLimitMsgOpen] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const [errorMsg, setErrorMsg] = useState(null);
  const [location, setLocation] = useState(false);
  const [openClaim, setOpenClaim] = useState(false);
  const [limitModalMsgOpen, setLimitModalMsgOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [form] = Form.useForm();
  // Fix: useBreakpoint from Ant Design
  const screens = useBreakpoint();
  const today = new Date();
  const checkLimit = events.filter((event) => event.code === id)[0];
  const mockStatusData = {
    requestId: 'MEDIA-' + Math.random().toString(36).substr(2, 9).toUpperCase(),
    fullName: 'John Doe',
    mediaHouseName: 'Sample News Network',
    mediaType: 'Press',
    pressType: 'Electronic Media',
    submittedAt: new Date().toISOString(),
    status: 'pending',
    history: [
      {
        action: 'Application Submitted',
        status: 'completed',
        timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
        remarks: 'Application received successfully'
      },
      {
        action: 'Under Review',
        status: 'current',
        timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        remarks: 'Being reviewed by admin team'
      },
      {
        action: 'Verification',
        status: 'pending',
        timestamp: null,
        remarks: 'Document verification pending'
      }
    ]
  };
  // Function to toggle modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleLimitClose = () => {
    setLimitMsgOpen(false);
    setErrorMsg(null);
    setLocation(false);
  };


  const handleModalClose = () => {
    setModalOpen(false);
    setOpenClaim(false);
    setLimitModalMsgOpen(false);
  };

  // Extract first two words of the address
  const getShortAddress = (address) => {
    const words = address.split(" ");
    return words.slice(0, 3).join(" ") + (words.length > 2 ? "..." : "");
  };

  // ... (keep all your existing functions like fetchAddress, handleLanguageChange, etc.)
  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };




  const translations = {
    English: {
      registerForm: "Media Registration",
      firstName: "Full Name",
      lastName: "Last Name",
      mobileNumber: "Mobile Number",
      email: "Email",
      register: "Submit",
      android: "Android",
      ios: "iOS",
      web: "Web Pass",
      mobile: "Mobile Pass",
      selectEventPlaceholder: "Select an Event",
      event1: "Kumar Vishwas Event 14 December",
      event2: "Kumar Vishwas Event 15 December",
      event3: "Kumar Vishwas Event 16 December",
      event4: "Abhang Vari Event 17 December",
      event5: "Abhijat Marathi Event 18 December",
      event6: "Fusion Event 19 December",
      event7: "Sanam Band Live Event 23 December",
      event8: "Udit Narayan 21 December",
      event9: "Vishal Mishra Event 22 December",
      select: "Choose event",
      selected: "Selected event",
      download: "Download Gate Pass",
      view: "View Gate Pass",
      mediaHouseName: "Media House Name",
      line: "Register by filling in the required details to receive your media pass.",
      choose: "Choose Event",
      terms: "Terms and Conditions",
      termsAndConditions: {
        title: "Terms and Conditions",
        items: [
          {
            title: "First-Come, First-Serve:",
            description:
              " Entry is granted on a first-come, first-serve basis. Holding a media pass does not guarantee entry if the venue reaches capacity.",
          },
          {
            title: "Non-Transferable:",
            description:
              "The  media pass is issued to the individual named on it and is strictly non-transferable. Attempts to sell or exchange the pass will result in cancellation.",
          },


          {
            title: "Right to Refuse Entry:",
            description:
              "The organizer reserves the right to deny entry to anyone who fails to comply with the event's dress code, behavioral policies, or safety guidelines, even if they hold a media pass.",
          },
        ],
      },
    },
    Hindi: {
      registerForm: "रजिस्टर फॉर्म",
      firstName: "पूरा नाम",
      mobileNumber: "मोबाइल नंबर",
      email: "ईमेल",
      register: "रजिस्टर करें",
      android: "एंड्रॉयड",
      ios: "आईओएस",
      web: "वेब पास",
      mobile: "मोबाइल पास",
      selectEventPlaceholder: "एक कार्यक्रम चुनें",
      event1: "कुमार विश्वास इवेंट 14 दिसंबर",
      event2: "कुमार विश्वास इवेंट 15 दिसंबर",
      event3: "कुमार विश्वास इवेंट 16 दिसंबर",
      event4: "अभंग वारी इवेंट 17 दिसंबर",
      event5: "अभिजात मराठी इवेंट 18 दिसंबर",
      event6: "फ्यूजन इवेंट 19 दिसंबर",
      event7: "विशाल मिश्रा इवेंट 22 दिसंबर",
      event8: "उदित नारायण 21 दिसंबर",
      event9: "विशाल मिश्रा इवेंट 23 दिसंबर",
      download: "गेट पास डाउनलोड करें",
      view: "गेट पास देखें",
      line: "आवश्यक विवरण भरकर पंजीकरण करें और अपना ऑनलाइन इवेंट पास प्राप्त करें। अपना पास डाउनलोड करना न भूलें। कृपया ध्यान दें, डुप्लिकेट पास जारी नहीं किया जाएगा। समय से पहले आएं और अपना गेट पास तैयार रखें।",
      choose: "इवेंट चुनें",
      selected: "चयनित इवेंट",
      terms: "नियम और शर्तें",
      termsAndConditions: {
        title: "नियम और शर्तें",
        items: [
          {
            title: "पहले आओ, पहले पाओ:",
            description:
              "मुफ्त प्रवेश पहले आओ, पहले पाओ के आधार पर दिया जाता है। मुफ्त पास रखने से यह सुनिश्चित नहीं होता कि अगर स्थान भर जाए तो प्रवेश मिलेगा।",
          },
          {
            title: "अप्रत्यावर्तनीय:",
            description:
              "मुफ्त प्रवेश पास उस व्यक्ति को जारी किया जाता है जिसका नाम उस पर है और यह स्थानांतरित नहीं किया जा सकता। पास को बेचना या बदलने की कोशिश से रद्द कर दिया जाएगा।",
          },
          {
            title: "उम्र की सीमा:",
            description:
              "प्रवेश उम्र की जांच के अधीन है। एकल आगंतुकों को न्यूनतम उम्र की आवश्यकता (16+) पूरी करनी होगी और प्रवेश द्वार पर वैध पहचान पत्र प्रदान करना होगा।",
          },
          {
            title: "सीमित वैधता:",
            description:
              "मुफ्त प्रवेश पास केवल निर्दिष्ट इवेंट तिथि और समय के लिए मान्य है। इसे अन्य इवेंट्स या तारीखों के लिए भुनाया नहीं जा सकता।",
          },
          {
            title: "प्रवेश से इनकार करने का अधिकार:",
            description:
              "आयोजक को इवेंट के ड्रेस कोड, व्यवहार नीतियों, या सुरक्षा निर्देशों का पालन न करने वालों को प्रवेश देने का अधिकार है, भले ही उनके पास मुफ्त प्रवेश पास हो।",
          },
        ],
      },
    },
    Marathi: {
      registerForm: "उपस्थित राहण्यासाठी नोंदणी",
      firstName: "पूर्ण नाव",
      mobileNumber: "मोबाइल नंबर",
      email: "ईमेल",
      register: "नोंदणी करा",
      android: "एंड्रॉइड",
      ios: "आयओएस",
      web: "वेब पास",
      mobile: "मोबाइल पास",
      selectEventPlaceholder: "एक कार्यक्रम निवडा",
      event1: "कुमार विश्वास कार्यक्रम 14 डिसेंबर",
      event2: "कुमार विश्वास कार्यक्रम 15 डिसेंबर",
      event3: "कुमार विश्वास कार्यक्रम 16 डिसेंबर",
      event4: "अभंग वारी कार्यक्रम 17 डिसेंबर",
      event5: "अभिजात मराठी कार्यक्रम 18 डिसेंबर",
      event6: "फ्यूजन कार्यक्रम 19 डिसेंबर",
      event7: "उदित नारायण 21 डिसेंबर",
      event8: "विशाल मिश्रा कार्यक्रम 22 डिसेंबर",
      event9: "विशाल मिश्रा कार्यक्रम 23 डिसेंबर",
      download: "गेट पास डाउनलोड करा",
      view: "गेट पास पहा",
      line: "आवश्यक तपशील भरून नोंदणी करा आणि आपला ऑनलाइन इव्हेंट पास प्राप्त करा. आपला पास डाउनलोड करायला विसरू नका. कृपया लक्षात घ्या, डुप्लिकेट पास जारी केला जाणार नाही. लवकर या आणि आपला गेट पास तयार ठेवा.",
      choose: "इव्हेंट निवडा",
      selected: "निवडलेला कार्यक्रम",
      terms: " नियम आणि अटी",
      termsAndConditions: {
        title: "नियम आणि अटी",
        items: [
          {
            title: "प्रथम ये, प्रथम सेवा:",
            description:
              "मोफत प्रवेश प्रथम ये, प्रथम सेवा युक्तीवर दिला जातो. मोफत पास असणे ह्याचा अर्थ नाही की तुम्हाला प्रवेश मिळेल, विशेषतः जर जागा भरलेली असेल.",
          },
          {
            title: "अक्षुण्ण ठेवण्याची अट:",
            description:
              "मोफत प्रवेश पास त्या व्यक्तीस दिला जातो ज्याचं नाव त्यावर आहे आणि हा पास हस्तांतरीत केला जाऊ शकत नाही. पास विक्री किंवा हस्तांतरण केल्यास तो रद्द होईल.",
          },
          {
            title: "वयाची अट:",
            description:
              "प्रवेश वय तपासणीला अधीन आहे. एकटे येणाऱ्यांनी किमान वयाची अट (१६+) पूर्ण करणे आवश्यक आहे आणि प्रवेशद्वारावर वैध ओळखपत्र देणे आवश्यक आहे.",
          },
          {
            title: "मर्यादित वैधता:",
            description:
              "मोफत प्रवेश पास केवळ निर्दिष्ट इव्हेंटच्या तारखेस आणि वेळेस वैध आहे. इतर इव्हेंट्स किंवा तारखांसाठी ते बदलता येणार नाही.",
          },
          {
            title: "प्रवेश नाकारण्याचा अधिकार:",
            description:
              "संगठकाला इव्हेंटच्या पोशाख नियम, वर्तन धोरणे किंवा सुरक्षा मार्गदर्शक तत्त्वांचे पालन न करणाऱ्यांना प्रवेश नाकारण्याचा अधिकार आहे, जरी त्यांच्याकडे मोफत प्रवेश पास असेल.",
          },
        ],
      },
    },
  };
  const currentTranslations = translations[selectedLanguage].termsAndConditions;
  //for developement env && Mongo atlas

  const findID = () => {
    const evnetID = selectedEvent || id;
    if (evnetID === "JbNy20242312KSMHVIPA5") {
      return "6767d2fccbace8e3647c2e59";
    } else if (evnetID === "JbNy20242312KSMHVIPA1") {
      return "6767d304cbace8e3647c2e5b";
    } else if (evnetID === "JbNy20242312KSMHVIP2") {
      return "6768503a5eab4e79ee56c930";
    } else if (evnetID === "JbNy20242312KSMHVIP3") {
      return "676850425eab4e79ee56c932";
    } else if (evnetID === "JbNy20242312KSMHVIP4") {
      return "676850535eab4e79ee56c934";
    }
  };

  // for production
  // const findID = () => {
  //   const evnetID = selectedEvent || id;
  //   if (evnetID === "AbWr1712KSMH") {
  //     return "67432288a2c442c836d4a806";
  //   } else if (evnetID === "AbMr1812KSMH") {
  //     return "674322b2a2c442c836d4a808";
  //   } else if (evnetID === "FuSo1912KSMH") {
  //     return "674322d4a2c442c836d4a80a";
  //   } else if (evnetID === "SBdL2012KSMH") {
  //     return "674322f2a2c442c836d4a80c";
  //   } else if (evnetID === "UdNn2112KSMH") {
  //     return "67432311a2c442c836d4a80e";
  //   } else if (evnetID === "VsMa2212KSMH") {
  //     return "67432332a2c442c836d4a810";
  //   } else if (evnetID === "GrMA1312KSMH") {
  //     return "6743219da2c442c836d4a7fe";
  //   } else if (evnetID === "KrVw1412KSMH") {
  //     return "67432233a2c442c836d4a800";
  //   } else if (evnetID === "KrVw1512KSMH") {
  //     return "6743224ea2c442c836d4a802";
  //   } else if (evnetID === "KrVw1612KSMH") {
  //     return "67432266a2c442c836d4a804";
  //   }
  // };


  const handleViewStatus = () => {
    setStatusModalOpen(true);
    setStatusData(null);
  };
  const handleStatusModalClose = () => {
    setStatusModalOpen(false);
    setStatusData(null);
    form.resetFields();
    setSearchAttempted(false);
  };

  const handleStatusSearch = async (values) => {
    setSearchLoading(true);
    setSearchAttempted(true);
    // console.log(values)
    // return
    try {
      const response = await fetch("/api/mediastatus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobileNumber: values.mobileNumber

        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch status');
      }

      if (data.success) {
        setStatusData(data.data);
        // message.success('Request found!');
      } else {
        // message.error(data.message || 'Request not found');
        setStatusData(null);
      }
    } catch (error) {
      console.error('Status check error:', error);
      // message.error(error.message || 'Request not found. Please check your mobile number and try again.');
      setStatusData(null);
    } finally {
      setSearchLoading(false);
    }
  };

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    // console.log("Form values:", values);

    if (loading) {
      setSubmitting(false);
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("firstName", values.fullName);
      formData.append("mobileNumber", values.mobileNumber);
      formData.append("mediaHouseName", values.mediaHouseName);
      formData.append("designation", values.mediaType);

      // Add location data if available
      if (pincode) formData.append("pincode", pincode);
      if (address) formData.append("address", address);
      if (lat) formData.append("lat", lat);
      if (long) formData.append("lng", long);

      // Add conditional fields for Press
      if (values.mediaType === "Press") {
        formData.append("pressType", values.pressType);
        if (values.pressType === "Print Media" && values.photographerName) {
          formData.append("photographerName", values.photographerName);
        } else if (values.pressType === "Electronic Media" && values.cameramanName) {
          formData.append("cameramanName", values.cameramanName);
        }
      }
      // Add conditional fields for Influencer
      else if (values.mediaType === "Influencer") {
        if (values.platformNames && values.platformNames.length > 0) {
          formData.append("platformNames", JSON.stringify(values.platformNames));
        }
        // Handle followersCounts array
        if (values.followersCounts && values.followersCounts.length > 0) {
          formData.append("followersCount", values.followersCounts.join(","));
        }

        // Handle socialMediaLinks array
        if (values.socialMediaLinks && values.socialMediaLinks.length > 0) {
          formData.append("socialMediaLinks", JSON.stringify(values.socialMediaLinks));
        }
      }

      // Handle document upload
      if (values.document) {
        formData.append("document", values.document);
      }

      // // Add event information if available
      // if (selectedEvent || id) {
      //   formData.append("eventCode", selectedEvent || id);
      // }

      // console.log("formdata", ...formData.entries())

      // return
      const response = await fetch("/api/new/save/details", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        alert("Your request has been submitted successfully. Please wait for admin approval.");
        resetForm();
        // setOpenModal(true);
      } else {
        console.error("Registration failed:", data);
        alert(data?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error while registering:", error);
      alert("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const filteredEvents = id
    ? events.filter((event) => event.code === id)
    : events;


  const generatePDFGatePass = async (data, fileName) => {
    try {
      // ID Card dimensions in inches (vertical orientation)
      const widthInches = 2.50;
      const heightInches = 3.70;

      // Convert to pixels for HTML (96 DPI)
      const widthPixels = widthInches * 96;
      const heightPixels = heightInches * 96;

      // Create PDF with ID card size
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'in',
        format: [widthInches, heightInches]
      });

      // Function to adjust font size dynamically
      const adjustFontSize = (element, container, baseSize, minSize, increaseThreshold = 15) => {
        if (!element || !container) return;

        const textContent = element.textContent.trim();
        const charCount = textContent.length;
        const maxHeight = container.clientHeight;

        // Start with larger size if text is short
        let fontSize = charCount < increaseThreshold ? baseSize + 2 : baseSize;
        element.style.fontSize = fontSize + 'px';

        // Force reflow
        void element.offsetHeight;

        // Reduce font size if content overflows
        let attempts = 0;
        while (element.scrollHeight > maxHeight && fontSize > minSize && attempts < 20) {
          fontSize -= 1;
          element.style.fontSize = fontSize + 'px';
          void element.offsetHeight; // Force reflow each iteration
          attempts++;
        }
      };

      // Function to generate a single page
      const generatePage = async (isFrontSide) => {
        // Create a temporary container for the gate pass
        const container = document.createElement('div');
        container.style.cssText = `
            position: absolute;
            top: -10000px;
            left: -10000px;
            width: ${widthPixels}px;
            height: ${heightPixels}px;
            overflow: hidden;
            background: white;
            font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Arial', sans-serif;
          `;

        if (isFrontSide) {
          // FRONT SIDE HTML with FIXED CONTAINERS
          container.innerHTML = `
              <div style="
                position: relative;
                width: 100%;
                height: 100%;
                overflow: hidden;
              ">
                <!-- Front Background Image -->
                <img src="/frontside.svg" alt="Gate Pass Background" style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  z-index: 0;
                " crossorigin="anonymous" onerror="this.src='https://placehold.co/240x355/ffcdd2/7A1A4E?text=FRONT+SIDE+BG'" />
    
                <!-- Content Overlay (Dynamic Data) with FIXED POSITIONS -->
                <div style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 1;
                  display: flex;
                  flex-direction: column;
                  box-sizing: border-box;
                ">
                  
                  <!-- Top Spacer - FIXED HEIGHT -->
                  <div style="
                    height: 75px;
                    flex-shrink: 0;
                  "></div>
    
                  <!-- NAME SECTION - FIXED CONTAINER -->
                  <div id="nameContainer" style="
                    width: 100%;
                    height: 42px;
                    padding: 0 8px;
                    box-sizing: border-box;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    overflow: hidden;
                  ">
                    <div id="nameText" style="
                      font-weight: 700;
                      font-size: 18px;
                      color: #a31740;
                      line-height: 1.2;
                      max-width: 100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      word-break: break-word;
                    ">
                      ${data.name}
                    </div>
                  </div>
    
                  <!-- MEDIA HOUSE NAME - FIXED CONTAINER -->
                  <div id="mediaHouseContainer" style="
                    width: 100%;
                    height: 32px;
                    padding: 0 8px;
                    box-sizing: border-box;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    overflow: hidden;
                  ">
                    <div id="mediaHouseText" style="
                      font-weight: 500;
                      font-size: 12px;
                      color: #a31740;
                      line-height: 1.3;
                      max-width: 100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      word-break: break-word;
                    ">
                      ${data.mediaHouse}
                    </div>
                  </div>
    
                  <!-- QR Code Container - FIXED SIZE -->
                  <div style="
                    width: 140px;
                    height: 130px;
                    margin: 0 auto;
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: white;
                  ">
                    <img 
                      src="${data.qrCodeLink}" 
                      alt="QR Code"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                      "
                      onload="console.log('QR Code loaded successfully')"
                      onerror="console.error('QR Code failed to load:', this.src.substring(0, 100) + '...')"
                    />
                  </div>
    
                  <!-- Spacer between QR and Pass Type - FIXED HEIGHT -->
                  <div style="
                    height: 29px;
                    flex-shrink: 0;
                  "></div>
                  
                  <!-- PASS TYPE - FIXED CONTAINER (takes remaining space) -->
                  <div style="
                    width: 100%;
                    flex: 1;
                    min-height: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 2px 4px;
                    box-sizing: border-box;
                    overflow: hidden;
                  ">
                    <div id="passTypeText" style="
                      font-weight: 700;
                      font-size: 21px;
                      color: #ffffff;
                      line-height: 1.2;
                      text-transform: uppercase;
                      text-align: center;
                      letter-spacing: 1px;
                      max-width: 100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      word-break: break-word;
                    ">
                      ${data.passType}
                    </div>
                  </div>
                </div>
              </div>
            `;
        } else {
          // BACK SIDE HTML
          container.innerHTML = `
              <div style="
                position: relative;
                width: 100%;
                height: 100%;
                overflow: hidden;
              ">
                <!-- Back Background Image -->
                <img src="/backside.svg" alt="Gate Pass Back Side" style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  z-index: 0;
                " crossorigin="anonymous" onerror="this.src='https://placehold.co/240x355/ffffff/000000?text=BACK+SIDE+BG'" />
              </div>
            `;
        }

        document.body.appendChild(container);

        // Wait for background image to load
        const bgImage = container.querySelector('img');
        if (bgImage && !bgImage.complete) {
          await new Promise((resolve) => {
            bgImage.onload = resolve;
            bgImage.onerror = resolve;
            setTimeout(resolve, 2000);
          });
        }

        if (isFrontSide) {
          // Wait for fonts to load
          if (document.fonts && document.fonts.ready) {
            await document.fonts.ready;
          }

          // Additional wait for rendering
          await new Promise(resolve => setTimeout(resolve, 100));

          // Apply dynamic font sizing AFTER container is attached and rendered
          const nameText = container.querySelector('#nameText');
          const nameContainer = container.querySelector('#nameContainer');
          adjustFontSize(nameText, nameContainer, 20, 12, 15);

          const mediaHouseText = container.querySelector('#mediaHouseText');
          const mediaHouseContainer = container.querySelector('#mediaHouseContainer');
          adjustFontSize(mediaHouseText, mediaHouseContainer, 14, 9, 15);

          // Wait a bit more for font adjustments to render
          await new Promise(resolve => setTimeout(resolve, 200));
        } else {
          // For back side, just wait for rendering
          await new Promise(resolve => setTimeout(resolve, 300));
        }

        // Generate canvas with high quality
        const canvas = await html2canvas(container, {
          scale: 4,
          useCORS: true,
          allowTaint: true,
          width: widthPixels,
          height: heightPixels,
          backgroundColor: '#ffffff',
          logging: false,
          imageTimeout: 0
        });

        document.body.removeChild(container);

        return canvas.toDataURL('image/jpeg', 0.95);
      };

      // Generate front side
      const frontSideImage = await generatePage(true);

      // Add front side to PDF
      pdf.addImage(frontSideImage, 'JPEG', 0, 0, widthInches, heightInches);

      // Add back side as new page
      pdf.addPage();
      const backSideImage = await generatePage(false);
      pdf.addImage(backSideImage, 'JPEG', 0, 0, widthInches, heightInches);

      // Save the PDF with both pages
      pdf.save(fileName);

    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  };

  return (
    <div>
      <Grid container justify="center" spacing={2}>
        <Grid
          item
          style={{ position: "absolute", top: 3, left: 0, cursor: "pointer" }}
          onClick={handleOpen}
        >
          <CiLocationOn size={25} /> <>{getShortAddress(address)}</>
        </Grid>
        <Grid item style={{ position: "absolute", top: -15, right: 0 }}>

        </Grid>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Full Address</DialogTitle>
          <DialogContent>
            <Typography variant="body1">{address}</Typography>
          </DialogContent>
        </Dialog>

        {/* Centered Logo */}
        <Grid
          item
          xs={12}
          style={{ textAlign: "center", backgroundColor: "#fffcde" }}
        >
          <img src="/khasdar.jpg" alt="Logo" className={classes.logo} />
        </Grid>
        <Marquee data={translations[selectedLanguage].line} />

        {(today >= new Date(checkLimit?.startDate) &&
          today <= new Date(checkLimit?.endDate)) ||
          !id ? (
          <div
            style={{
              background: "url('/Banner.png') no-repeat center center",
              backgroundSize: "cover",
              minHeight: "85vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "90%",
              padding: "20px 0"
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: screens.xs ? "95%" : "650px",
                // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: screens.xs ? "8px" : "16px",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)"
              }}
            >
              <AntCard
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                  border: "none",

                }}
                bodyStyle={{
                  padding: screens.xs ? "20px" : "32px"
                }}
              >
                {/* <Typography variant="h5" style={{
                  textAlign: "center",
                  marginBottom: "8px",
                  color: "#343434",
                  fontWeight: 500
                }}>
                  {translations[selectedLanguage].registerForm}
                </Typography> */}

                <Typography.Text
                  style={{
                    textAlign: "center",
                    display: "block",
                    marginBottom: "32px",
                    color: "black",
                    fontSize: "28px",
                    fontWeight: 500
                  }}
                >
                  Media Registration
                </Typography.Text>


                {/* Quick Status Link */}
                <div style={{
                  textAlign: "center",
                  marginBottom: "24px",
                  padding: "12px",
                  background: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  borderRadius: "6px"
                }}>
                  <Text type="secondary">
                    Already submitted your application?{' '}
                    <Text
                      style={{
                        color: '#1890ff',
                        fontWeight: 500,
                        cursor: 'pointer',
                        // textDecoration: 'underline'
                      }}
                      onClick={handleViewStatus}
                    >
                      Check your request status here
                    </Text>
                  </Text>
                </div>
                <Formik
                  initialValues={{
                    fullName: "",
                    mobileNumber: "",
                    mediaHouseName: "",
                    mediaType: "",
                    document: null,
                    pressType: "",
                    photographerName: "",
                    cameramanName: "",
                    followersCounts: [""],
                    socialMediaLinks: [""]
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    handleSubmit,
                    isValid,
                    dirty,
                    isSubmitting
                  }) => (
                    <AntForm layout="vertical" onFinish={handleSubmit}>
                      <Row gutter={[0, 16]}>
                        {/* Full Name */}
                        <Col xs={24}>
                          <AntForm.Item
                            label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Full Name</span>}
                            required
                            validateStatus={
                              touched.fullName && errors.fullName ? "error" : ""
                            }
                            help={touched.fullName && errors.fullName}
                            style={{ marginBottom: '12px' }}
                            labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                          >
                            <AntInput
                              placeholder="Enter your full name"
                              name="fullName"
                              value={values.fullName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              size="large"
                              style={{ borderRadius: '8px' }}
                            // maxLength={14} // restricts input to 13 characters
                            />

                          </AntForm.Item>
                        </Col>

                        {/* Mobile Number */}
                        <Col xs={24}>
                          <AntForm.Item
                            label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Mobile Number</span>}
                            required
                            validateStatus={
                              touched.mobileNumber && errors.mobileNumber ? "error" : ""
                            }
                            help={touched.mobileNumber && errors.mobileNumber}
                            style={{ marginBottom: '12px' }}
                            labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                          >
                            <AntInput
                              placeholder="Enter 10-digit mobile number"
                              name="mobileNumber"
                              value={values.mobileNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              size="large"
                              maxLength={10}
                              style={{ borderRadius: '8px' }}
                            />
                          </AntForm.Item>
                        </Col>

                        {/* Media House Name */}
                        <Col xs={24}>
                          <AntForm.Item
                            label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Media House Name</span>}
                            required
                            validateStatus={
                              touched.mediaHouseName && errors.mediaHouseName ? "error" : ""
                            }
                            help={touched.mediaHouseName && errors.mediaHouseName}
                            style={{ marginBottom: '12px' }}
                            labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                          >
                            <AntInput
                              placeholder="Enter media house name"
                              name="mediaHouseName"
                              value={values.mediaHouseName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              size="large"
                              style={{ borderRadius: '8px' }}
                            />
                          </AntForm.Item>
                        </Col>

                        {/* Media Type */}
                        {/* <Col xs={24}>
                          <AntForm.Item
                            label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Media Type</span>}
                            required
                            validateStatus={
                              touched.mediaType && errors.mediaType ? "error" : ""
                            }
                            help={touched.mediaType && errors.mediaType}
                            style={{ marginBottom: '12px' }}
                            labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                          >
                            <AntSelect
                              placeholder="Select media type"
                              size="large"
                              value={values.mediaType || undefined}
                              onChange={(value) => {
                                setFieldValue("mediaType", value);
                                // Reset conditional fields when media type changes
                                setFieldValue("pressType", "");
                                setFieldValue("photographerName", "");
                                setFieldValue("cameramanName", "");
                                setFieldValue("followersCount", "");
                                setFieldValue("socialMediaLinks", [""]);
                              }}
                              onBlur={handleBlur}
                              style={{ borderRadius: '8px' }}
                            >
                              <Option value="Press">
                                <Space>
                                  <BankOutlined />
                                  Press
                                </Space>
                              </Option>
                              <Option value="Mobile Reporter">
                                <Space>
                                  <PhoneOutlined />
                                  Mobile Reporter
                                </Space>
                              </Option>
                              <Option value="Influencer">
                                <Space>
                                  <UserOutlined />
                                  Influencer
                                </Space>
                              </Option>
                            </AntSelect>
                          </AntForm.Item>
                        </Col> */}
                        <Col xs={24}>
                          <AntForm.Item
                            label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Media Type</span>}
                            required
                            validateStatus={
                              touched.mediaType && errors.mediaType ? "error" : ""
                            }
                            help={touched.mediaType && errors.mediaType}
                            style={{ marginBottom: '12px' }}
                            labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                          >
                            <AntSelect
                              placeholder="Select media type"
                              size="large"
                              value={values.mediaType || undefined}
                              onChange={(value) => {
                                setFieldValue("mediaType", value);
                                // Reset conditional fields when media type changes
                                setFieldValue("pressType", "");
                                setFieldValue("photographerName", "");
                                setFieldValue("cameramanName", "");
                                setFieldValue("followersCount", "");
                                setFieldValue("socialMediaLinks", [""]);
                              }}
                              onBlur={handleBlur}
                              style={{ borderRadius: '8px' }}
                            >
                              <Option value="Print Media">
                                <Space>
                                  <FileTextOutlined />
                                  Print Media
                                </Space>
                              </Option>
                              <Option value="Electronic Media">
                                <Space>
                                  <DesktopOutlined />
                                  Electronic Media
                                </Space>
                              </Option>
                              <Option value="Cameraman">
                                <Space>
                                  <VideoCameraOutlined />
                                  Cameraman
                                </Space>
                              </Option>
                              <Option value="Photographer">
                                <Space>
                                  <CameraOutlined />
                                  Photographer
                                </Space>
                              </Option>
                              <Option value="Digital Media">
                                <Space>
                                  <GlobalOutlined />
                                  Digital Media
                                </Space>
                              </Option>

                              <Option value="Influencer">
                                <Space>
                                  <UserOutlined />
                                  Influencer
                                </Space>
                              </Option>
                            </AntSelect>
                          </AntForm.Item>
                        </Col>

                        {/* 
                        {values.mediaType === "Press" && (
                          <>
                            <Col xs={24}>
                              <AntForm.Item
                                label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Press Type</span>}
                                required
                                validateStatus={
                                  touched.pressType && errors.pressType ? "error" : ""
                                }
                                help={touched.pressType && errors.pressType}
                                style={{ marginBottom: '12px' }}
                                labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                              >
                                <AntSelect
                                  placeholder="Select press type"
                                  size="large"
                                  value={values.pressType || undefined}
                                  onChange={(value) => {
                                    setFieldValue("pressType", value);
                                    setFieldValue("photographerName", "");
                                    setFieldValue("cameramanName", "");
                                  }}
                                  onBlur={handleBlur}
                                  style={{ borderRadius: '8px' }}
                                >
                                  <Option value="Print Media">
                                    <Space>
                                      <FileImageOutlined />
                                      Print Media
                                    </Space>
                                  </Option>
                                  <Option value="Electronic Media">
                                    <Space>
                                      <VideoCameraOutlined />
                                      Electronic Media
                                    </Space>
                                  </Option>
                                </AntSelect>
                              </AntForm.Item>
                            </Col>

                            {values.pressType === "Print Media" && (
                              <Col xs={24}>
                                <AntForm.Item
                                  label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Photographer Name</span>}
                                  required
                                  validateStatus={
                                    touched.photographerName && errors.photographerName ? "error" : ""
                                  }
                                  help={touched.photographerName && errors.photographerName}
                                  style={{ marginBottom: '12px' }}
                                  labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                                >
                                  <AntInput
                                    prefix={<UserOutlined style={{ color: '#8c8c8c' }} />}
                                    placeholder="Enter photographer name"
                                    name="photographerName"
                                    value={values.photographerName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    style={{ borderRadius: '8px' }}
                                  />
                                </AntForm.Item>
                              </Col>
                            )}

                            {values.pressType === "Electronic Media" && (
                              <Col xs={24}>
                                <AntForm.Item
                                  label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Cameraman Name</span>}
                                  required
                                  validateStatus={
                                    touched.cameramanName && errors.cameramanName ? "error" : ""
                                  }
                                  help={touched.cameramanName && errors.cameramanName}
                                  style={{ marginBottom: '12px' }}
                                  labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                                >
                                  <AntInput
                                    prefix={<UserOutlined style={{ color: '#8c8c8c' }} />}
                                    placeholder="Enter cameraman name"
                                    name="cameramanName"
                                    value={values.cameramanName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    style={{ borderRadius: '8px' }}
                                  />
                                </AntForm.Item>
                              </Col>
                            )}
                          </>
                        )} */}

                        {values.mediaType === "Influencer" && (
                          <>
                            {values.followersCounts.map((followerCount, index) => (
                              <React.Fragment key={index}>
                                <Col xs={24}>
                                  <AntForm.Item
                                    label={<span style={{ fontWeight: 500, fontSize: '14px' }}>
                                      Platform Name {values.followersCounts.length > 1 ? `#${index + 1}` : ''}
                                    </span>}
                                    required
                                    validateStatus={
                                      touched.platformNames?.[index] && errors.platformNames?.[index] ? "error" : ""
                                    }
                                    help={touched.platformNames?.[index] && errors.platformNames?.[index]}
                                    style={{ marginBottom: '12px' }}
                                    labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                                  >
                                    <AntInput
                                      prefix={<GlobalOutlined style={{ color: '#8c8c8c' }} />}
                                      placeholder="e.g., Instagram, YouTube, Twitter"
                                      value={values.platformNames?.[index] || ''}
                                      onChange={(e) => {
                                        const newPlatformNames = [...(values.platformNames || [])];
                                        newPlatformNames[index] = e.target.value;
                                        setFieldValue("platformNames", newPlatformNames);
                                      }}
                                      onBlur={handleBlur}
                                      name={`platformNames[${index}]`}
                                      size="large"
                                      style={{ borderRadius: '8px' }}
                                    />
                                  </AntForm.Item>
                                </Col>

                                <Col xs={24}>
                                  <AntForm.Item
                                    label={<span style={{ fontWeight: 500, fontSize: '14px' }}>
                                      Number of Followers {values.followersCounts.length > 1 ? `#${index + 1}` : ''}
                                    </span>}
                                    required
                                    validateStatus={
                                      touched.followersCounts?.[index] && errors.followersCounts?.[index] ? "error" : ""
                                    }
                                    help={touched.followersCounts?.[index] && errors.followersCounts?.[index]}
                                    style={{ marginBottom: '12px' }}
                                    labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                                  >
                                    <AntInput
                                      type="number"
                                      prefix={<TeamOutlined style={{ color: '#8c8c8c' }} />}
                                      placeholder="Enter number of followers"
                                      value={followerCount}
                                      onChange={(e) => {
                                        const newFollowersCounts = [...values.followersCounts];
                                        newFollowersCounts[index] = e.target.value;
                                        setFieldValue("followersCounts", newFollowersCounts);
                                      }}
                                      onBlur={handleBlur}
                                      name={`followersCounts[${index}]`}
                                      size="large"
                                      min={0}
                                      style={{ borderRadius: '8px' }}
                                    />
                                  </AntForm.Item>
                                </Col>

                                <Col xs={24}>
                                  <AntForm.Item
                                    label={<span style={{ fontWeight: 500, fontSize: '14px' }}>
                                      Social Media Link {values.socialMediaLinks.length > 1 ? `#${index + 1}` : ''}
                                    </span>}
                                    required
                                    validateStatus={
                                      touched.socialMediaLinks?.[index] && errors.socialMediaLinks?.[index] ? "error" : ""
                                    }
                                    help={touched.socialMediaLinks?.[index] && errors.socialMediaLinks?.[index]}
                                    style={{ marginBottom: '12px' }}
                                    labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                                  >
                                    <Space style={{ width: "100%", display: 'flex', gap: '8px' }} align="start">
                                      <AntInput
                                        prefix={<LinkOutlined style={{ color: '#8c8c8c' }} />}
                                        placeholder="https://example.com/profile"
                                        value={values.socialMediaLinks[index]}
                                        onChange={(e) => {
                                          const newLinks = [...values.socialMediaLinks];
                                          newLinks[index] = e.target.value;
                                          setFieldValue("socialMediaLinks", newLinks);
                                        }}
                                        onBlur={handleBlur}
                                        name={`socialMediaLinks[${index}]`}
                                        size="large"
                                        style={{
                                          width: '100%',
                                          minWidth: 0,
                                          borderRadius: '8px',
                                        }}
                                      />
                                      {(values.followersCounts.length > 1 || values.socialMediaLinks.length > 1) && (
                                        <AntButton
                                          type="text"
                                          danger
                                          icon={<MinusCircleOutlined />}
                                          onClick={() => {
                                            // Remove platform name, follower count and link at the same index
                                            const newPlatformNames = (values.platformNames || []).filter((_, i) => i !== index);
                                            const newFollowersCounts = values.followersCounts.filter((_, i) => i !== index);
                                            const newLinks = values.socialMediaLinks.filter((_, i) => i !== index);
                                            setFieldValue("platformNames", newPlatformNames);
                                            setFieldValue("followersCounts", newFollowersCounts);
                                            setFieldValue("socialMediaLinks", newLinks);
                                          }}
                                          size="large"
                                          style={{ flexShrink: 0, borderRadius: '8px' }}
                                        />
                                      )}
                                    </Space>
                                  </AntForm.Item>
                                </Col>

                                {index < values.followersCounts.length - 1 && (
                                  <Col xs={24}>
                                    <Divider style={{ margin: '16px 0' }} />
                                  </Col>
                                )}
                              </React.Fragment>
                            ))}

                            {/* Add Button */}
                            <Col xs={24}>
                              <AntButton
                                type="dashed"
                                onClick={() => {
                                  // Add platform name, follower count and social media link fields
                                  setFieldValue("platformNames", [...(values.platformNames || []), ""]);
                                  setFieldValue("followersCounts", [...values.followersCounts, ""]);
                                  setFieldValue("socialMediaLinks", [...values.socialMediaLinks, ""]);
                                }}
                                icon={<PlusOutlined />}
                                size="large"
                                block
                                style={{ borderRadius: '8px', marginTop: '16px' }}
                              >
                                Add Social Media Platform
                              </AntButton>
                            </Col>
                          </>
                        )}


                        {/* Upload ID Document */}
                        <Col xs={24}>
                          <AntForm.Item
                            label={<span style={{ fontWeight: 500, fontSize: '14px' }}>Upload ID Document</span>}
                            required
                            validateStatus={touched.document && errors.document ? "error" : ""}
                            help={touched.document && errors.document}
                            style={{ marginBottom: '12px' }}
                            labelCol={{ style: { paddingBottom: '4px', marginBottom: 0 } }}
                          >
                            <Upload
                              name="document"
                              listType="picture-card"
                              maxCount={1}
                              beforeUpload={(file) => {
                                // File type validation
                                const isSupportedType = [
                                  'image/jpeg',
                                  'image/jpg',
                                  'image/png',
                                  'application/pdf'
                                ].includes(file.type);

                                // File size validation (5MB)
                                const isLt5M = file.size / 1024 / 1024 < 5;

                                if (!isSupportedType) {
                                  message.error('You can only upload PDF, JPG, JPEG, or PNG files!');
                                  return false;
                                }

                                if (!isLt5M) {
                                  message.error('File must be smaller than 5MB!');
                                  return false;
                                }

                                setFieldValue("document", file);
                                return false; // Prevent automatic upload
                              }}
                              onRemove={() => setFieldValue("document", null)}
                              accept=".pdf,.jpg,.jpeg,.png"
                              fileList={values.document ? [{
                                uid: '-1',
                                name: values.document.name,
                                status: 'done',
                                size: values.document.size,
                                type: values.document.type,
                                url: values.document.type.startsWith('image/')
                                  ? URL.createObjectURL(values.document)
                                  : '/pdf-icon.png' // You can add a PDF icon
                              }] : []}
                              itemRender={(originNode, file) => (
                                <div style={{ position: 'relative' }}>
                                  {originNode}
                                  {file.size > 5 * 1024 * 1024 && (
                                    <div style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      background: 'rgba(255,0,0,0.7)',
                                      color: 'white',
                                      padding: '2px',
                                      fontSize: '10px',
                                      textAlign: 'center'
                                    }}>
                                      File too large
                                    </div>
                                  )}
                                </div>
                              )}
                            >
                              <div style={{ padding: '1px', textAlign: 'center' }}>
                                <UploadOutlined style={{ fontSize: '20px', color: '#1890ff', display: 'block', margin: '0 auto' }} />
                                <div style={{ marginTop: 8, color: '#595959', fontSize: '10px' }}>
                                  Click or drag file to upload
                                </div>
                                <div style={{ marginTop: 4, color: '#8c8c8c', fontSize: '8px' }}>
                                  PDF, JPG, PNG (Max 5MB)
                                </div>
                              </div>
                            </Upload>
                          </AntForm.Item>
                        </Col>
                      </Row>

                      {/* Submit Button */}
                      <Row justify="center">
                        <Col xs={24}>
                          <AntButton
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={loading}
                            disabled={!isValid || !dirty || loading}
                            block
                            style={{
                              height: "50px",
                              fontSize: "16px",
                              fontWeight: 600,
                              borderRadius: "8px",
                              background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
                              border: "none",
                              boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                              color: "#fff"
                            }}
                          >
                            {loading ? "Submitting..." : translations[selectedLanguage].register}
                          </AntButton>
                        </Col>
                      </Row>
                    </AntForm>
                  )}
                </Formik>
              </AntCard>
            </div>
          </div>

        ) : today < new Date(checkLimit?.startDate) ? (
          <Typography variant="h6" style={{ color: "#FF5733", textAlign: "center" }}>
            Starting 18th December, secure your online entry pass for the event!
          </Typography>
        ) : today > new Date(checkLimit?.endDate) ? (
          <Typography variant="h6" style={{ textAlign: "center" }}>
            This Event is No Longer Active! Thank you for your interest. Stay tuned for upcoming events.
          </Typography>
        ) : null}
      </Grid>

      <StatusCheckModal
        open={statusModalOpen}
        onClose={handleStatusModalClose}
        statusData={statusData}
        onSearch={handleStatusSearch}
        searchLoading={searchLoading}
        searchAttempted={searchAttempted}
        form={form}
        generatePDFGatePass={generatePDFGatePass}
      />

      <UniqueMobileNumberAlert
        open={isModalOpen}
        onClose={handleModalClose}
        openClaim={openClaim}
        setOpenClaim={setOpenClaim}
        setResponse={setResponse}
        selectedEvent={findID()}
      />
      <UniqueLimitMsgModal
        open={limitModalMsgOpen}
        onClose={handleModalClose}
        openClaim={openClaim}
        setOpenClaim={setOpenClaim}
        setResponse={setResponse}
        selectedEvent={findID()}
      />

      {response && (
        <UniqueGatePass
          event={response}
          selectedEvent={selectedEvent || id}
          download={translations[selectedLanguage].download}
          view={translations[selectedLanguage].view}
          modalCloseRef={modalCloseRef}
        />
      )}

      <div
        style={{
          maxWidth: "600px", // Limit the width to a card size
          margin: "0 auto", // Center the content horizontally
          textAlign: "left", // Keep the text alignment left
          padding: "16px", // Add some padding for spacing
          color: "#000000",
        }}
      >
        <h4 style={{ marginBottom: "10px", paddingLeft: "10px", fontWeight: 600 }}>
          {translations[selectedLanguage].terms}
        </h4>

        {/* custom bullet list (works even if global UL styles are reset) */}
        <div>
          {(currentTranslations?.items || []).map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: 10,
              }}
            >
              {/* bullet */}
              <div
                style={{
                  width: 2,
                  height: 8,
                  borderRadius: "50%",
                  background: "#000",
                  marginTop: 8,
                  flex: "0 0 6px",
                }}
              />
              {/* content */}
              <div style={{ marginLeft: 12, color: "#000" }}>
                <strong style={{ fontWeight: 600 }}>{item.title}</strong>{" "}
                <span>{item.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          background: "linear-gradient(to right, #2A5D87, #004AAD, #002A52)", // Footer background gradient
          padding: "10px 15px", // Padding for spacing
          display: "flex", // Flexbox for alignment
          justifyContent: "center", // Center content horizontally
          alignItems: "center", // Center content vertically
          textAlign: "center", // Align text in the center
          color: "white", // Text color
          fontSize: "14px", // Adjust text size for responsiveness
          fontFamily: "'Arial', sans-serif", // Clean font
        }}
      >
        <a
          href="https://www.bharat-online.com/"
          target="_blank" // Opens link in a new tab
          rel="noopener noreferrer" // Security measure
          style={{ textDecoration: "none", color: "inherit" }} // Remove underline and use parent color
        >
          <span style={{ display: "flex", alignItems: "center" }}>
            Developed and Maintained By
            <img
              src="/bharatOnline.png"
              alt="bharatOnline"
              crossOrigin="anonymous"
              style={{
                marginLeft: "6px", // Space between text and image
                marginRight: "6px", // Space after image
                height: "25px", // Set image size
              }}
            />
            <span style={{ fontWeight: "bold" }}>Bharat Online</span>
          </span>
        </a>
      </div>

      <Dialog open={limitMsgOpen} onClose={handleLimitClose}>
        <DialogTitle>{errorMsg}</DialogTitle>

        <DialogActions>
          <Button onClick={handleLimitClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UniqueGatepass;

